import {createFileRoute, redirect} from '@tanstack/react-router'

/** Redirect to /jobs/create for the quote. */
export const Route = createFileRoute('/_app/quotes/$quoteId/create-project/')({
    beforeLoad: ({params}) => {
        throw redirect({to: '/jobs/create', search: {quote: params.quoteId}, replace: true})
    },
})
